/* eslint-disable @next/next/no-img-element */
import Logo from '@/lib/assets/eva-kita-logo.svg';

import AnchorLink from './AnchorLink';
import Container from './Container';

type FooterProps = {
  description?: React.ReactNode;
  navItems?: {
    label: string;
    url: string;
  }[];
  logos?: {
    src: string;
    alt: string;
    url: string;
  }[];
};

const Footer = ({ description, navItems, logos }: FooterProps) => {
  return (
    <footer>
      <Container className="grid items-center gap-6 py-4 lg:grid-cols-3">
        <Logo className="mx-auto max-w-[16rem] px-4 lg:order-2" />
        <div className="text-center text-lg lg:order-1 lg:text-left">{description}</div>
        <nav className="lg:order-3">
          <ul className="flex justify-center gap-7 text-lg lg:justify-end">
            {navItems?.map((navItem) => (
              <li key={navItem.url}>
                <AnchorLink className="text-lg" href={navItem.url}>
                  {navItem.label}
                </AnchorLink>
              </li>
            ))}
          </ul>
        </nav>
      </Container>
      <div className="bg-sand-100 py-10">
        <Container className="flex flex-wrap items-center justify-center gap-8">
          {logos?.map((logo) => (
            <a key={logo.url} href={logo.url} className="block" target="_blank" rel="noopener noreferrer">
              <img className="h-16 w-60 object-contain" src={logo.src} alt={logo.alt} />
            </a>
          ))}
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
